import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'services/localization/useTranslation';
import BackdropDialog, { DialogAction } from 'common/components/BackdropDialog';
import { DepositReserveType } from '.';

interface Props {
	onConfirm: (type: DepositReserveType) => void;
	onCancel: () => void;
	reservationType: 'manual' | 'payment_card';
}

const DepositReserveDialog = ({ onConfirm, onCancel, reservationType }: Props) => {
	const { t } = useTranslation();
	const showReserveNow = reservationType === 'payment_card';

	const reserveNowButtonProps: DialogAction = {
		label: t('payment.reserveNow', 'Reserve now'),
		callback: () => onConfirm('RESERVE_NOW'),
		color: 'primary',
		variant: 'contained',
	};

	const markAsReservedButtonProps: DialogAction = {
		label: t('payment.markAsReserved', 'Mark as reserved'),
		callback: () => onConfirm('MARK_AS_RESERVED'),
		color: 'primary',
		variant: showReserveNow ? 'outlined' : 'contained',
	};

	const goBackButtonProps: DialogAction = {
		label: t('common:actions.goBack'),
		callback: onCancel,
		color: 'primary',
		variant: 'text',
	};

	return (
		<BackdropDialog
			isOpen={true}
			onClose={onCancel}
			label={t('depositReserveDialog.title', 'Reserve deposit') + '?'}
			body={
				<>
					<Typography variant="body1">
						{reservationType === 'manual'
							? t(
									'depositReserveDialog.noPaymentCard2',
									'This order does not have customer payment card stored',
							  )
							: t(
									'depositReserveDialog.hasPaymentCard2',
									'The deposit for this order is automatically reserved 24 hours before the start time from the payment card of the customer',
							  )}
						{'.'}
					</Typography>
					<Typography variant="body1" sx={{ mt: 1 }}>
						{reservationType === 'manual'
							? t(
									'depositReserveDialog.markReservedOnly',
									'Deposit can only be marked as being reserved outside of Rentle',
							  )
							: t(
									'depositReserveDialog.reserveOrMarkReserved',
									'You can also reserve the deposit immediately, or mark the deposit as reserved outside of the Rentle system',
							  )}
						{'.'}
					</Typography>
				</>
			}
			confirm={showReserveNow ? reserveNowButtonProps : markAsReservedButtonProps}
			cancel={showReserveNow ? markAsReservedButtonProps : goBackButtonProps}
			leftActionBtn={showReserveNow ? goBackButtonProps : undefined}
		/>
	);
};

export default DepositReserveDialog;
